import { render } from "./DashboardScreen.vue?vue&type=template&id=8baa4dc4&scoped=true"
import script from "./DashboardScreen.vue?vue&type=script&lang=js"
export * from "./DashboardScreen.vue?vue&type=script&lang=js"

import "./DashboardScreen.vue?vue&type=style&index=0&id=8baa4dc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8baa4dc4"]])

export default __exports__